import React from "react";
import { clientsCampaignsSummaryApi } from "../../api/organizerClientsApi";
import useCarga from "./useCarga";

/* Monthly send summary of Clientes > Campañas: sent / skipped / failed per campaign, last 6 months. */

const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
export const nombreDeMes = (ym) => {
  const m = /^(\d{4})-(\d{2})$/.exec(ym || "");
  return m && MESES[Number(m[2]) - 1] ? `${MESES[Number(m[2]) - 1]} ${m[1]}` : ym || "";
};
const num = (c, k) => Number(c?.[k]) || 0;
const hayEnvios = (m) => ["birthday", "winback"].some((t) => num(m[t], "sent") + num(m[t], "skipped") + num(m[t], "failed") > 0);

const CampanasResumen = ({ refreshKey = 0 }) => {
  const { loading, error, data, reload } = useCarga(() => clientsCampaignsSummaryApi(6), refreshKey, {
    valida: (i) => Array.isArray(i.months),
    mensaje: "No pudimos cargar el resumen de envíos.",
  });
  const meses = (data?.months || []).filter(hayEnvios);

  return (
    <section className="zr-panel" aria-label="Resumen de envíos">
      <h3 className="zr-subhead__title">Envíos de los últimos 6 meses</h3>
      {loading && !data && <p className="fc-hint" role="status">Cargando resumen…</p>}
      {error && !data && (
        <div className="fc-error" role="alert">
          {error.message} <button type="button" className="zr-btn zr-btn--soft" onClick={reload}>Reintentar</button>
        </div>
      )}
      {data && meses.length === 0 && (
        <div className="fc-empty">
          <p>Todavía no se enviaron campañas.</p>
          <p>Cuando prendas una, vas a ver acá cuántos mensajes salieron.</p>
        </div>
      )}
      {meses.length > 0 && (
        <div className="zr-table-wrap">
          <table className="zr-table">
            <thead>
              <tr>
                <th rowSpan={2}>Mes</th>
                <th colSpan={3}>Cumpleaños</th>
                <th colSpan={3}>Te extrañamos</th>
              </tr>
              <tr>
                {["Enviados", "Omitidos", "Fallidos", "Enviados", "Omitidos", "Fallidos"].map((t, i) => <th key={i}>{t}</th>)}
              </tr>
            </thead>
            <tbody>
              {meses.map((m) => (
                <tr key={m.month}>
                  <td>{nombreDeMes(m.month)}</td>
                  {["birthday", "winback"].flatMap((t) => ["sent", "skipped", "failed"].map((k) => <td key={`${t}-${k}`}>{num(m[t], k)}</td>))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default CampanasResumen;
